import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  .MuiFormLabel-root {
    font-size: 14px;
    top: -2px;
  }

  .MuiInputBase-root {
    font-size: 14px;

    input {
      padding: 0 12px;
      height: 38px;
      cursor: pointer;

      &::placeholder {
        color: ${theme.palette.secondary.main};
        opacity: 1;
      }
    }
  }
`;
